<template>
  <div class="sidepanel-reminders">
    <!-- Automated reminder start -->
        <EditPollSection 
    v-model="diplayReminderDetails"
    :showPremium="true"
    :title="$t('automateReminder.title')"
     />

    <template v-if="diplayReminderDetails">
      <div
        class="description"
        v-html="$t('automateReminder.description')"
      ></div>
      <div class="reminder-in-days d-flex mt-2" style="max-width: 400px;">
        <div class="reminder-in-days-options1">
          <input
            type="checkbox"
            id="days_5"
            value="5"
            class="mandatory-email mr-10"
            :disabled="isDisableChoices"
            v-model="delayInterval"
          />
          <label
            for="days_5"
            :class="[
              isDisableChoices ? 'disabled-text' : '',
              'font-weight-500',
            ]"
            >{{ $t('automateReminder.5Days') }}</label
          >
        </div>
        <div class="reminder-in-days-options2">
          <input
            type="checkbox"
            id="days_3"
            value="3"
            class="mandatory-email mr-10"
            :disabled="isDisableChoices"
            v-model="delayInterval"
          />
          <label
            for="days_3"
            :class="[
              isDisableChoices ? 'disabled-text' : '',
              'font-weight-500',
            ]"
          >
            {{ $t('automateReminder.3Days') }}
          </label>
        </div>
        <div class="reminder-in-days-options3">
          <input
            type="checkbox"
            id="days_1"
            value="1"
            class="mandatory-email mr-10"
            :disabled="isDisableChoices"
            v-model="delayInterval"
          />
          <label
            for="days_1"
            :class="[
              isDisableChoices ? 'disabled-text' : '',
              'font-weight-500',
            ]"
            >{{ $t('automateReminder.1Day') }}
          </label>
        </div>
      </div>

      <div class="reminder-options mt-2">
        <div class="reminder-options1">
          <input
            type="radio"
            class="radio-button mr-10"
            :disabled="isDisableBeforeDealine"
            id="before_deadline_1"
            value="before_deadline"
            name="autoReminderDeadlineOption"
            v-model="delayType"
          />
          <label
            :class="[
              isDisableBeforeDealine ? 'disabled-text' : '',
              'font-weight-500',
            ]"
            for="before_deadline_1"
            >{{ $t('automateReminder.beforeDeadline') }} ({{
              deadlineForReminder
            }})</label
          >
        </div>
        <!-- :disabled = "isDisableBeforeNextDateOption" -->
        <div class="reminder-options2">
          <input
            type="radio"
            :disabled="true"
            class="radio-button mr-10"
            id="before_deadline_2"
            value="before_next_date"
            name="autoReminderDeadlineOption"
            v-model="delayType"
          />
          <label
            :class="[
              isDisableBeforeNextDateOption ? 'disabled-text' : '',
              'font-weight-500',
            ]"
            for="before_deadline_2"
          >
            <!-- {{$t('automateReminder.beforeNextDateOption')}} ({{ beforeNextDateForReminder }})  -->
            {{ $t('automateReminder.beforeNextDateOption') }} ({{
              $t('automateReminder.notAvailable')
            }})
          </label>
        </div>
      </div>
    </template>
    <!-- Automated reminder end -->
  </div>
</template>
<script>


import { formValidationMixin } from '@/components/mixins/FormValidationMixin.js';
import { dateMixin } from '@/components/mixins/DateMixins.js';
import { renderMixin } from '../mixins/RenderMixins';
import EditPollSection from '@/components/Edit/EditPollSection.vue';

import { mapState, mapGetters } from 'vuex';

import { extend, localize } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import en from 'vee-validate/dist/locale/en.json';

import moment from 'moment';
// import CustomBrandingTemplates from './CustomBrandingTemplates.vue';


extend('required', required);
localize('en', en);

export default {
  name: 'EditKulibri',

  props: ['backup'],
  mixins: [formValidationMixin, dateMixin, renderMixin],

  components: {
    EditPollSection
  },

  data() {


    return {
      autoReminderDeadlineOption: '',
      diplayReminderDetails: false,
      diplayAppearanceDetails: false,
    };
  },

  computed: {
    ...mapState({
      poll: (state) => state.poll.poll,
      ownerId: (state) => state.poll.poll.user.id,
      user: (state) => state.Login.user,
    }),

    ...mapGetters({
      isAdmin: 'isAdmin',
      isPremium: 'isPremium',

    }),

    pollDeadline() {
      return this.poll.deadline;
    },

    /* get formated dealine for reminder -> radio btton -> before dealine  */
    deadlineForReminder() {
      try {
        if (!this.pollDeadline) return this.$t('automateReminder.notSet'); // date not found than reurn default message (not set)
        return moment(String(this.pollDeadline)).format(
          this.$t('automateReminder.dateFomatForUI')
        ); //format date to dd.mm.yyyy and return
      } catch (error) {
        console.error(error);
        return '';
      }
    },

    /** get formated date from polls choice for rediobutton ->  before next date option*/
    beforeNextDateForReminder() {
      try {
        if (this.poll && this.poll.type && this.poll.type != 1)
          return this.$t('automateReminder.availableInDatePollOnly');
        if (this.pollDeadline) return this.$t('automateReminder.notAvailable'); // date not found than reurn default message (not available)
        let _days;
        if (this.poll.delay_interval) {
          _days = this.poll.delay_interval;
          _days = _days.sort((a, b) => b - a);
        }
        /** if poll date found than return first date by substract days */
        if (this.poll && this.poll.choices && this.poll.choices.length > 0) {
          let todayDate = moment(new Date()).format(
            this.$t('automateReminder.dateFomatForUI')
          );
          for (let i = 0; i < this.poll.choices.length; i++) {
            if (this.poll.choices[i].start) {
              for (
                let deadlineIndex = 0;
                deadlineIndex < _days.length;
                deadlineIndex++
              ) {
                let date = moment(String(this.poll.choices[i].start))
                  .subtract(_days[deadlineIndex], 'days')
                  .format(this.$t('automateReminder.dateFomatForUI')); //substtract by largest days and format
                if (date >= todayDate) {
                  return moment(this.poll.choices[i].start).format(
                    this.$t('automateReminder.dateFomatForUI')
                  );
                }
              }
            }
          }
        }
        return this.$t('automateReminder.notAvailable');
      } catch (error) {
        console.error(error);
        return this.$t('automateReminder.notAvailable');
      }
    },

    /* enable or disable automatedReminder days ->  check boxs*/
    isDisableChoices() {
      try {
        if (!this.isPremium || !this.poll.deadline) return true;

        // let choice = null;
        // if(this.poll && this.poll.choices && this.poll.choices.length > 0){
        //   choice = this.poll.choices
        // }
        // if(!this.pollDeadline && !choice || choice == null)  return true;

        return false;
      } catch (error) {
        console.error(error);
        return false;
      }
    },

    /** disable  -> redio button -> before dealine */
    isDisableBeforeDealine() {
      if (!this.isPremium) return true;

      let choice = null;
      if (this.poll && this.poll.choices && this.poll.choices.length > 0) {
        choice = this.poll.choices;
      }

      if (!this.pollDeadline && (!choice || choice == null)) return true;

      if (choice && choice.length > 0 && !this.pollDeadline) return true;

      return false;
    },
    /* disable -> radio btton -> before next date option */
    isDisableBeforeNextDateOption() {
      if (
        !this.isPremium ||
        (this.poll && this.poll.type && this.poll.type != 1)
      )
        return true;

      let choice = null;
      if (this.poll && this.poll.choices && this.poll.choices.length > 0) {
        choice = this.poll.choices;
      }

      if (
        (!this.pollDeadline && (!choice || choice == null)) ||
        (choice && choice.length > 0 && this.pollDeadline)
      ) {
        return true;
      }

      return false;
    },
    delayInterval: {
      get() {
        return this.poll.delay_interval || [];
      },
      set(value) {
        this.$store.commit('updateDelayInterval', value);
      },
    },

    delayType: {
      get() {
        if (this.poll.delay_type) {
          return this.poll.delay_type;
        }
        return null;
      },
      set(value) {
        this.$store.commit('updateDelayType', value);
      },
    },

    
    
  },

  watch: {
    delayInterval: {
      deep: true,
      handler: function () {
        this.delayType =
          this.pollDeadline && this.delayInterval.length > 0
            ? 'before_deadline'
            : null;
      },
    },
  },

  methods: {},

  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '@/styles/style';
// input.form-control:focus {
//   box-shadow: 0 0px 0px rgba(0, 0, 0, 0.075) inset,
//     0 0 0px rgba(126, 239, 104, 0.6);
//   outline: 0 none;
// }


.mr-10 {
  margin-right: 10px !important;
}

.backgroundButton {
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.logo-manager-parent {
  cursor: pointer;
  justify-content: space-between;
  .logo-image-update {
    display: block;
  }
  // label, button {
  //   word-break: break-word;
  //   white-space: normal;
  //   width: 100px;
  //   color: $primary;
  // }
}
.disabled-text{
  color: gray !important;
}
.reminder-in-days {
  justify-content: space-between;
}
</style>
